<div class="modal-header">
  <h4 class="modal-title appearance-title" id="appearance-title">Appearance</h4>
  <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div class="data-showcase-grid">
    <p class="appearance-hint">
      The preview updates as you choose. It shows the MiniMenu landing screen your customers open first.
    </p>

    <div class="row appearance-grid">
      <!-- Preview first: you read the result, then reach right for the controls. -->
      <div class="col-lg-6">
        <div class="appearance-preview">
          <div class="mm-phone" [style.font-family]="fontStack"
               [style.background-color]="working.backgroundColor"
               [style.color]="working.contentColor">
            <div class="mm-head" [style.color]="working.uiColor">
              <span class="mm-loc">{{ previewLocation }}</span>
              <span class="mm-lang" [style.border-color]="working.uiColor">EN</span>
              <span class="mm-site">Hungery.id</span>
            </div>

            <div class="mm-center">
              <span class="mm-mark" [style.background-color]="working.uiColor"
                    [style.color]="working.backgroundColor">
                {{ businessName.charAt(0) || 'H' }}
              </span>
              <div class="mm-ey" [style.color]="working.accentColor">{{ previewEyebrow }}</div>
              <p class="mm-sub">{{ previewSubline }}</p>
            </div>

            <div class="mm-actions">
              <span class="mm-row" [style.border-color]="working.accentColor">
                <span>What's On</span><span [style.color]="working.accentColor">&rarr;</span>
              </span>
              <span class="mm-row mm-row-solid" [style.background-color]="working.uiColor"
                    [style.color]="working.backgroundColor" [style.border-color]="working.uiColor">
                <span>View Menu</span><span>&rarr;</span>
              </span>
            </div>
          </div>
          <p class="appearance-preview-note">Landing screen &middot; mobile</p>
        </div>
      </div>

      <!-- Controls -->
      <div class="col-lg-6">
        <div class="row appearance-controls">
          <div class="col-12">
            <app-select [options]="fonts" [selectClass]="'ng-form-select primary-select'"
                        selectPlaceholder="Select Font" label="Font" [selectedValue]="fontSelect"
                        (selectedValueChange)="onFontChange($event)"></app-select>
          </div>
          <div class="col-6">
            <label class="data-label" for="appearanceBg">Background</label>
            <input id="appearanceBg" type="color" class="form-control appearance-color"
                   [(ngModel)]="working.backgroundColor" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="col-6">
            <label class="data-label" for="appearanceUi">Interface</label>
            <input id="appearanceUi" type="color" class="form-control appearance-color"
                   [(ngModel)]="working.uiColor" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="col-6">
            <label class="data-label" for="appearanceInk">Content Text</label>
            <input id="appearanceInk" type="color" class="form-control appearance-color"
                   [(ngModel)]="working.contentColor" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="col-6">
            <label class="data-label" for="appearanceAccent">Accent</label>
            <input id="appearanceAccent" type="color" class="form-control appearance-color"
                   [(ngModel)]="working.accentColor" [ngModelOptions]="{standalone: true}" />
          </div>
        </div>
      </div>
    </div>

    <!-- Canon sizes its primary action at w-50 centred (ImageConfigurationComponent footer). -->
    <div class="btn-grps appearance-actions">
      <app-button [btnText]="'Save'" [btnTitle]="'Save'" [btnCss]="'btn btn-primary w-100 btn-lg'"
                  (onBtnClick)="save()"></app-button>
      <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-text w-100 btn-md'"
                  (onBtnClick)="cancel()"></app-button>
    </div>
  </div>
</div>
